import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { WORK_REGISTER_ENDPOINTS, WORK_REGISTER_PAGE_SIZE } from '../config/settings/constant'

import { REACT_APP_MINVU_BASE_URL, REACT_APP_MOP_BASE_URL } from '../config/settings/environment'

const { MINVU, MOP } = WORK_REGISTER_ENDPOINTS

const minvuBaseUrl = `${REACT_APP_MINVU_BASE_URL}/v1/${MINVU}/registro/paged`
const mopBaseUrl = `${REACT_APP_MOP_BASE_URL}/v1/${MOP}/registro/paged`

/**
 * Retrieves paginated MINVU registry data for a specific user and register code.
 */
export const getMinvuRegistry = factoryService(({ dni, page, registerCode }) => {
  const params = new URLSearchParams({
    codigoRegistro: registerCode,
    page,
    rut: dni,
    size: WORK_REGISTER_PAGE_SIZE
  }).toString()

  return getJsonRequest(`${minvuBaseUrl}?${params}`)
})

/**
 * Retrieves paginated MOP registry data for a specific user and register code.
 */
export const getMopRegistry = factoryService(({ dni, page, registerCode }) => {
  const params = new URLSearchParams({
    codigoRegistro: registerCode,
    page,
    rut: dni,
    size: WORK_REGISTER_PAGE_SIZE
  }).toString()

  return getJsonRequest(`${mopBaseUrl}?${params}`)
})
